import { environment } from '../constants/environment';

export const debugLog = (title: string, message: any = '') => {
  if (!environment.DEBUG_MODE) return;

  console.log(title, message);
};
